import React, { useEffect, useMemo, useState } from "react";
import farmerImage from "../../assets/images/farmer.jpg";
import familyImage from "../../assets/images/family.jpg";
import womanImage from "../../assets/images/woman.jpg";
import manImage from "../../assets/images/man.jpg";
import AccountTypeInfo from "../../Components/AccountTypeInfo";
import style from "./style.module.css";
import Loader from "../../Components/Loader";
import CbnFooter from "../../Components/CbnFooter";
import Tabs from "../../Components/Tabs/Tabs";
import CustomDropdown from "../../Components/CustomDropdown";
import AltBankLogo from "../../Components/AltbankLogo";
import useImageSlider from "../../customHooks/useImageSlider";
import apiHooks from "../../customHooks/apis";
import { errorToast } from "../../utils/makeToast";

function PersonalAccount(props: any) {
  const { returnActiveClass } = useImageSlider();
  const [accountType, setAccountType] = useState(null);
  const [currentTab, setCurrentTab] = useState("");
  const { useGetSavingsAccountTypes, useGetCurrentAccountTypes } = apiHooks;
  const { savingsAccountTypes, gettingSavingsAccountTypes } =
    useGetSavingsAccountTypes();
  const { currentAccountTypes, gettingCurrentAccountTypes } =
    useGetCurrentAccountTypes();
  const loading = gettingCurrentAccountTypes || gettingSavingsAccountTypes;
  const accountTypeDetails = useMemo(
    () =>
      currentTab === "Current"
        ? currentAccountTypes.find((item) => item.account_Type === accountType)
        : savingsAccountTypes.find((item) => item.account_Type === accountType),
    [currentAccountTypes, savingsAccountTypes, accountType, currentTab],
  );

  const resetAccountType = (tab: string) => {
    setAccountType(null);
    setCurrentTab(tab);
  };

  const handleAccountTypeSelect = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const { value } = event.target;
    const isMinorAccount = value.toLowerCase().includes("minor");
    const updatedValue = isMinorAccount ? "" : value;
    setAccountType(updatedValue);
    if (isMinorAccount) return errorToast("Coming soon!");
    localStorage.setItem("altFinanceAccountType", value);
  };

  useEffect(() => {
    if (window.location.href.includes("ex-personal-account")) {
      localStorage.setItem("accountStatus", "existing");
    } else {
      localStorage.setItem("accountStatus", "new");
    }
  }, []);

  useEffect(() => {
    accountTypeDetails &&
      localStorage.setItem("altFinanceGlCode", accountTypeDetails?.glCode);
  }, [accountTypeDetails]);

  return (
    <div>
      {loading ? <Loader /> : null}

      <div className="container-fluid row mx-0 p-0 vh-100">
        <div className="d-none d-md-inline col-md-4 p-0 mx-0 h-100 position-relative">
          <div className={style.logo}>
            <AltBankLogo />
          </div>
          <div
            id="carouselExampleSlidesOnly"
            className="carousel slide carousel-fade h-100"
            data-ride="carousel"
          >
            <div className="carousel-inner h-100" id="carousel-overlay">
              <div className={`carousel-item h-100 ${returnActiveClass(0)}`}>
                <img
                  src={farmerImage}
                  className="d-block w-100 h-100 object-fit-cover"
                  alt="farmer"
                />
              </div>
              <div className={`carousel-item ${returnActiveClass(1)}`}>
                <img
                  src={familyImage}
                  className="d-block w-100 h-100 object-fit-cover"
                  alt="family"
                />
              </div>
              <div className={`carousel-item ${returnActiveClass(2)}`}>
                <img
                  src={womanImage}
                  className="d-block w-100 h-100 object-fit-cover"
                  alt="women"
                />
              </div>
              <div className={`carousel-item ${returnActiveClass(3)}`}>
                <img
                  src={manImage}
                  className="d-block w-100 h-100 object-fit-cover"
                  alt="men"
                />
              </div>
            </div>
          </div>
          <div className={style.cbnFooterContainer}>
            <CbnFooter />
          </div>
        </div>

        <div className="col-md-8 p-2 px-4 pl-md-5 pr-md-5 h-100 overflow-auto">
          <div className="container mt-5 pt-5 mx-auto pl-md-4 pr-md-4">
            <h1 className="big-bold-texts text-left">Personal Account</h1>{" "}
            <br />
            <div className="small-label-texts text-left pb-2">
              Select account category
            </div>
            <Tabs
              tabNames={["Savings", "Current"]}
              onClickTab={resetAccountType}
            />
            <br />
            <br />
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-home"
                role="tabpanel"
                aria-labelledby="pills-home-tab"
              >
                <div className="select-group">
                  <CustomDropdown
                    placeholder="Select account type"
                    label="Select account type"
                    options={
                      currentTab === "Current"
                        ? currentAccountTypes
                        : savingsAccountTypes
                    }
                    labelKey="account_Type"
                    valueKey="account_Type"
                    extraDisplayClasses={style.select_field}
                    onClickOption={handleAccountTypeSelect}
                    value={accountType}
                  />
                </div>
              </div>
              {accountType && <AccountTypeInfo accountType={accountType} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PersonalAccount;
